module.exports = "images/3ans.51238047.png";